import { formatDate } from 'utils/functions/Date';

import { Tooltip, Typography } from '@project44/manifest-ds';
import { Nullable } from '@project44-models/shipment-list';

interface ICellDate {
  dateTime?: Nullable<string>;
}

function CellDate({ dateTime }: ICellDate) {
  return (
    <Tooltip title={dateTime}>
      <Typography variant="subtext" css={{ width: 'fit-content' }}>
        {dateTime ? formatDate(dateTime, 'MMM d, yyyy H:mm z') : '-'}
      </Typography>
    </Tooltip>
  );
}

export default CellDate;
